var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusInsideSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 11.9984C2.3999 7.47295 2.3999 5.21021 3.80579 3.80433C5.21168 2.39844 7.47442 2.39844 11.9999 2.39844C16.5254 2.39844 18.7881 2.39844 20.194 3.80433C21.5999 5.21021 21.5999 7.47295 21.5999 11.9984C21.5999 16.5239 21.5999 18.7867 20.194 20.1926C18.7881 21.5984 16.5254 21.5984 11.9999 21.5984C7.47442 21.5984 5.21168 21.5984 3.80579 20.1926C2.3999 18.7867 2.3999 16.5239 2.3999 11.9984Z",
    stroke: "#1552E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 11.9985L11.9999 11.9985M11.9999 11.9985L8.3999 11.9985M11.9999 11.9985L11.9999 8.39844M11.9999 11.9985L11.9999 15.5984",
    stroke: "#1552E8",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInsideSquare);
export default __webpack_public_path__ + "static/media/PlusInsideSquare.bb68a9f0cbeecce715e07c78feffff67.svg";
export { ForwardRef as ReactComponent };